/**
 * Controls navigation and display for Dealer Assets page
 */
class Assets {
  constructor() {
    this.tabs = document.querySelectorAll('[data-tab]');
    this.content = document.querySelectorAll('[data-tabcontent]');
    this.container = document.querySelector('.assets__tabcontent');
    
    this.urlchange = new Event('urlchange');
    this.events();
    document.dispatchEvent(this.urlchange)
  }

  events() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', this.changeTab.bind(this));
    });
    // Prevent multiple event assignments
    if(!document.clickEvent) {
      this.container.addEventListener('click', this.changeFolder.bind(this));
      document.clickEvent = true;
    }
    if(!document.urlchangeEvent) {
      document.addEventListener('urlchange', this.changeUrl.bind(this));
      document.urlchangeEvent = true;
    }
    window.onpopstate = e => {
      document.dispatchEvent(this.urlchange);
    }
    // delegated events for asset sort
    document.addEventListener('change', e => {
      const target = e.target.closest('.asset__sort--select');
      if (target !== null) {
        const form = document.querySelector('form[name="sortform"]');
        form.submit();
      }
    });
  }

  /**
   * Routes click to selectTab function
   * @param {ClickEvent} e 
   */
  changeTab(e) {
    const tab = e.target;
    this.selectTab(tab);
  }

  /**
   * Gets route from url, changes tab or loads file browser
   * @param {CustomEvent} e 
   */
  changeUrl(e) {
    const route_arr = location.pathname.split('/');
    const route = route_arr[route_arr.length -1];
    if(route == 'locations' || route == 'profile') {
      const tab = document.querySelector(`[data-tab='${route}']`);
      this.selectTab(tab)
    }
    this.load(route);
  }

  /**
   * Navigates through file browser
   * @param {ClickEvent} e 
   */
  changeFolder(e) {
    if(e.type == 'click') {
      if(e.target.classList.contains('assets__folder') || e.target.classList.contains('assets__breadcrumbs--crumb')) {
        const title = e.target.innerText;
        const route = e.target.dataset.route;
        history.pushState('', title, '/dealer-profile/' + route);
        document.dispatchEvent(this.urlchange);
      }
    }
  }
  /**
   * Fetches file browser data from api
   * @param {String} route 
   */
  load(route) {
    const url = 'assetsapi/assets/' + route + location.search;

    fetch(url,{
      method: 'GET',
      headers: {
        'Content-Type':'text/html',
        'x-requested-with': 'XMLHttpRequest'
      }
    })
    .then(response => response.json())
    .then(data => {
      this.buildBrowserUI(data);
    });
  }

  /**
   * Builds file browser UI from API data
   * @param {JSONObject} data 
   */
  buildBrowserUI(data) {
    let folders = '';
    let files = '';
    let breadcrumbs = '';
    let content = '';
    data.folders.forEach(item => {
      folders += this.folderButtonTemplate(item);
    });
    data.files.forEach(file => {
      files += this.fileTemplate(file)
    });
    data.breadcrumbs.forEach(crumb => {
      breadcrumbs += `<span class="assets__breadcrumbs--crumb" data-route="${crumb.slug}">${crumb.title}</span>`;
    })

    if(data.files.length == 0 && data.folders.length == 0) {
      content = `<p>No files found</p>`;
    } else {
      content = `<ul class="assets__folders">${folders}</ul>
      <ul class="assets__files">${files}</ul>`;
    }
    // get search query to preselect appropriate option
    const qs = location.search;
    const optasc = (qs.search('asc') < 0) ? '' : 'selected';
    const optdesc = (qs.search('desc') < 0) ? '' : 'selected';

    const html = `
      <div class="assets__headings">
        <h2>${data.title}</h2>
        <form action="" name="sortform" method="GET">
          <select class="asset__sort--select" name="sort">
            <option value="asc" ${optasc}>Sort ASC</option>
            <option value="desc" ${optdesc}>Sort DESC</option>
          </select>
        </form>
      </div>
      <div class="assets__breadcrumbs">
        <span class="assets__breadcrumbs--crumb" data-route="downloads">Downloads</span>${breadcrumbs}
      </div>
        ${content}
    `;

    this.container.innerHTML = html;
  }

  /**
   * @param {DOMElement} target 
   */
  selectTab(target) {
    const route = target.dataset.tab;
    const title = target.innerText;
    const content = document.querySelector(`[data-tabcontent = '${route}']`);

    this.tabs.forEach(tab => {
      tab.classList.remove('selected');
    });
    this.content.forEach(content => {
      content.classList.remove('dealer__tab--show');
    });

    target.classList.add('selected');
    content.classList.add('dealer__tab--show');
    history.pushState('', title, '/dealer-profile/' + route);
  }

  /**
   * Provides Templates for UI
   * @param {Object} folder 
   * @returns Template data
   */
  folderButtonTemplate(folder) {
    return `<li class="category-btn assets__folder" data-route="${folder.Slug}">${folder.Title}</li>`;
  }
  /**
   * Provides Templates for UI
   * @param {Object} file
   * @returns Template data
   */
   fileTemplate(file) {
     console.log(file);
    let thumb = file.Thumbnail;
    console.log(thumb);
    if(thumb) {
      thumb = `<img src="${thumb}">` || '';
    }
    return `<div class="assets__file">
      <div class="assets__file--thumbnail">${thumb}</div>
      <div class="assets__file--info">
        <h3>${file.Title}</h3>
        <p>${file.Type}</p>
        <a class="assets__file--download" href="${file.URL}" target="_blank">Download</a>
      </div>
    </div>
  `;
  }
}

export default Assets;